module.exports = __webpack_public_path__ + "static/gallery1-9b4aa226c793e109cea46c4a9d886af6.jpg";